export default "__VITE_ASSET__ChzUGlpv__"